import React from 'react';
import {connect} from 'react-redux';
import logo from '../../../assets/Images/hsag-logo-take2.jpg';

const Brand = ({epasrrUrl}) => (
  <div className="col-sm-4 col-md-4 col-logo">
    <div className="row">
      <a href={epasrrUrl} className="logo col-xs-12">
        <div>
          <img src={logo} className="img-responsive" alt="ePASRR"/>
        </div>
      </a>
    </div>
  </div>
);

export default connect(
  ({application}) => ({
    epasrrUrl: application.epasrrUrl
  })
)(Brand)


// WEBPACK FOOTER //
// ./src/modules/layout/components/Brand.js